module.exports = __webpack_public_path__ + "static/media/exam.e4c091bf.svg";